/**
 * CMSD dynamic header name.
 *
 * @group CMSD
 *
 * @beta
 */
export const CMSD_DYNAMIC = 'CMSD-Dynamic';
